import 'core-js';
import 'regenerator-runtime/runtime';

import React, { StrictMode } from 'react';

import Gallery from 'component/Accommodation/Gallery';
import GalleryContextProvider from 'component/Accommodation/Gallery/__context';
import { GALLERY_TARGET_ID } from 'component/Accommodation/Gallery/constants';
import FilterInfo from 'component/Search/Filter/FilterInfo';
import Contact from 'component/User/Contact';

import { AccommodationList } from 'pages/hotels/component/Accommodation/List';
import Header from 'pages/hotels/component/Accommodation/List/Header';
import { ActiveFilterList } from 'pages/hotels/component/Search/__partials/ActiveFilterList';
import { AccommodationDataProvider } from 'pages/hotels/context';
import HotelPageProvider from 'pages/hotels/context/HotelPageProvider';

import { ContactProvider } from 'context/ContactContext';
import { InternalOutputProvider } from 'context/InternalOutputContext';

import { SearchDProvider } from 'utility/Provide/Context/PageContext';

import Search from './component/Search';

export default function HotelEntry() {
    return (
        <ContactProvider>
            <Contact />
            <StrictMode>
                <HotelPageProvider>
                    <Search target="#portal-searchform" />
                    <GalleryContextProvider>
                        <ActiveFilterList
                            target="#portal-hotel-list-active-filter-list"
                            mapTarget="#portal-map-filter-bar"
                        />
                        <InternalOutputProvider>
                            <SearchDProvider>
                                <AccommodationDataProvider>
                                    <Header target="#portal-hotel-list-head" />
                                    <AccommodationList
                                        target="#portal-hotel-list"
                                        hasRecommender={false}
                                    />
                                    <FilterInfo target="#portal-filter-information" />
                                </AccommodationDataProvider>
                            </SearchDProvider>
                        </InternalOutputProvider>
                        <Gallery target={GALLERY_TARGET_ID} />
                    </GalleryContextProvider>
                </HotelPageProvider>
            </StrictMode>
        </ContactProvider>
    );
}
